export function createStripeTokenMetadata(billingAddress) {
    return {
        name: `${billingAddress.firstName} ${billingAddress.lastName}`,
        address_line1: billingAddress.address1,
        address_line2: billingAddress.address2,
        address_city: billingAddress.city,
        address_state: billingAddress.state,
        address_zip: billingAddress.postalCode,
        address_country: billingAddress.country
    };
}

export const CreditCardService = angular
    .module('checkout.creditCardService', [])
    .service('creditCardService', ($q, $window) => {
        const convertExpStringToObject = (expString) => {
            const exp = expString.split('/');
            return {
                expMonth: exp[0],
                expYear: exp[1]
            };
        };

        const createAuthorizeNetToken = ({ card, cart, publicClientKey, apiLoginId }) => {
            const { postalCode, firstName, lastName } = cart.billingAddress;

            const expStringParts = card.expiration.split('/');
            const expMonth = expStringParts[0];
            const expYear = expStringParts[1].substring(2, 4) || expStringParts[1];

            const deferred = $q.defer();
            $window.Accept.dispatchData({
                authData: {
                    clientKey: publicClientKey,
                    apiLoginID: apiLoginId
                },
                cardData: {
                    cardNumber: card.cardNumber,
                    month: expMonth,
                    year: expYear,
                    cardCode: card.cvc,
                    zip: postalCode,
                    fullName: `${firstName} ${lastName}`
                }
            }, (data) => {
                if (data.error) {
                    deferred.reject(data.error);
                } else {
                    deferred.resolve(data);
                }
            });
            return deferred.promise;
        };

        return {
            convertExpStringToObject,
            createAuthorizeNetToken
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/creditCard.service.js